export enum OnlineStatusType {
  OFFLINE = 'offline',
  ONLINE = 'online',
}
